export class BillOfQuantitesModel {
    public devicesAndMaterials: string;
    public labor: string;
}